class ObservableQuat {
  _x;
  _y;
  _z;
  _w;
  _onDirty;
  /** Bumped on every value change. Lets derived caches (e.g. the Euler proxy) detect
   *  external quaternion writes and re-sync only when needed. */
  _version = 0;
  constructor(x, y, z, w, onDirty) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._onDirty = onDirty;
  }
  /** Monotonic change counter — incremented whenever any component changes. */
  get version() {
    return this._version;
  }
  get x() {
    return this._x;
  }
  set x(v) {
    if (this._x !== v) {
      this._x = v;
      this._version++;
      this._onDirty();
    }
  }
  get y() {
    return this._y;
  }
  set y(v) {
    if (this._y !== v) {
      this._y = v;
      this._version++;
      this._onDirty();
    }
  }
  get z() {
    return this._z;
  }
  set z(v) {
    if (this._z !== v) {
      this._z = v;
      this._version++;
      this._onDirty();
    }
  }
  get w() {
    return this._w;
  }
  set w(v) {
    if (this._w !== v) {
      this._w = v;
      this._version++;
      this._onDirty();
    }
  }
  /** Bulk set — one dirty notification instead of four. */
  set(x, y, z, w) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._version++;
    this._onDirty();
  }
  /** Copy values from another quaternion. */
  copyFrom(q) {
    this.set(q.x, q.y, q.z, q.w);
  }
  /** Copy into a Float32Array at offset. */
  toArray(out, offset = 0) {
    out[offset] = this._x;
    out[offset + 1] = this._y;
    out[offset + 2] = this._z;
    out[offset + 3] = this._w;
  }
}

export { ObservableQuat };
//# sourceMappingURL=observable-quat.js.map
